module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "默认值",
      "prop": "default"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.textarea.write_default),
      expression: "curInput.textarea.write_default",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.curInput.textarea.write_default)
    },
    on: {
      "input": function($event) {
        _vm.curInput.textarea.write_default = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('textlen-config', {
    attrs: {
      "config": _vm.curInput.textarea,
      "limitMax": true,
      "maxCount": 500
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28e62e3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/textareaConfig.vue
// module id = 1797
// module chunks = 2